import { Link } from "react-router-dom";
import Logo from "../../icons/logo.svg";
import HeaderNavigation from "./HeaderNavigation";
import HeaderIcons from "./HeaderIcons";

export default function Header() {
  return (
    <header className="mt-10 mb-10 lg:mt-8 lg:mb-11">
      <div className="container flex justify-between items-center px-0 h-auto">
        <Link to="/"> {/* ← клік по логотипу веде на головну */}
          <img
            src={Logo}
            alt="Logo"
            className="w-[57px] h-[56px] md:w-[73px] md:h-[72px] xl:w-[68px] xl:h-[67px] rounded-2xl object-cover"
          />
        </Link>
        <HeaderNavigation />
        <HeaderIcons />
      </div>
    </header>
  );
}


